import { ConvexReactClient } from 'convex/react';

// Singleton Convex client for the player app. It is shared between the
// ConvexBetterAuthProvider (which attaches the signed-in player's token) and
// the imperative fallback query in utils/getCode.ts, so authed calls made
// outside React still carry the session.
//
// Null unless BOTH Convex env vars are configured: the client is useless
// without the auth routes (VITE_CONVEX_SITE_URL) and vice versa, so the pair
// is all-or-nothing. When unset (e.g. CI builds), open trails keep working
// through the public cached API without any Convex plumbing, and the
// account/redeem routes are disabled by AppRouter.
const convexUrl = import.meta.env.VITE_CONVEX_URL as string | undefined;
const convexSiteUrl = import.meta.env.VITE_CONVEX_SITE_URL as
  string | undefined;

export const playerAuthEnabled = Boolean(convexUrl && convexSiteUrl);

// Note: deliberately NOT passing `expectAuth: true`. That option pauses the
// socket until `setAuth`/`clearAuth` is called, but ConvexProviderWithAuth
// (via ConvexBetterAuthProvider) only calls either when the auth provider
// reports `authProviderAuthenticated` — i.e. never for a signed-out player.
// resolveByCodeForPlayer is a first-class unauthenticated path (see
// utils/getCode.ts), so a signed-out player hitting a mistyped code or an
// invite-only link would have the socket paused forever and stall on
// "loading" indefinitely.
export const convex = playerAuthEnabled
  ? new ConvexReactClient(convexUrl!)
  : null;
